import { useLang } from "@/lib/i18n";

/** The menu control: three crisp rules on a quiet plate, the last one drawn a
 *  little short and completing on hover so the control feels made, not drawn. */
export default function MenuButton({ onClick, className = "", ...rest }) {
  const { t } = useLang();

  return (
    <button
      type="button"
      onClick={onClick}
      {...rest}
      aria-label={t("menu.open")}
      className={`group grid h-10 w-10 place-items-center rounded-[12px] border border-black/[0.09] bg-white/90 text-[#34332f] transition-colors hover:border-black/25 hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#b84a3a]/40 dark:border-white/[0.14] dark:bg-[#24231f] dark:text-[#eeeae2] dark:hover:bg-[#2c2a24] ${className}`}
    >
      <span aria-hidden="true" className="flex w-[17px] flex-col gap-[3.5px]">
        <span className="h-[1.6px] w-full rounded-full bg-current" />
        <span className="h-[1.6px] w-full rounded-full bg-current" />
        <span className="h-[1.6px] w-[68%] rounded-full bg-current transition-[width] duration-200 group-hover:w-full" />
      </span>
    </button>
  );
}